<ix-modal-header
  [title]="'Add Snapshot' | translate"
  [loading]="isFormLoading"
></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset>
        <ix-select
          formControlName="dataset"
          [label]="helptext.snapshot_add_dataset_placeholder | translate"
          [tooltip]="helptext.snapshot_add_dataset_tooltip | translate"
          [options]="datasetOptions$"
          [required]="true"
        ></ix-select>

        <ix-input
          formControlName="name"
          [label]="helptext.snapshot_add_name_placeholder | translate"
          [tooltip]="helptext.snapshot_add_name_tooltip | translate"
        ></ix-input>

        <ix-select
          formControlName="naming_schema"
          [label]="helptext.snapshot_add_naming_schema_placeholder | translate"
          [tooltip]="helptext.snapshot_add_naming_schema_tooltip | translate"
          [options]="namingSchemaOptions$"
        ></ix-select>

        <ix-checkbox
          formControlName="recursive"
          [label]="helptext.snapshot_add_recursive_placeholder | translate"
          [tooltip]="helptext.snapshot_add_recursive_tooltip | translate"
        ></ix-checkbox>

        <ix-checkbox
          *ngIf="hasVmsInDataset"
          formControlName="vmware_sync"
          [label]="'VMWare Sync' | translate"
        ></ix-checkbox>
      </ix-fieldset>

      <ix-form-actions>
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
